(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("userOptions", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/user/options/userOptionsView.html",
            controller: ["frameworkService", "messageService", "tenantResource", "$translate", UserOptionsCtrl],
            controllerAs: "vm"
        };
        function UserOptionsCtrl(frameworkService, messageService, tenantResource, $translate) {
            var vm = this;
            vm.saving = false;
            //EXAMPLE $translate.onReady()
            $translate.onReady().then(function () {
                vm.ready = true;
            });
            vm.model = {
                userCanChangeEmail: frameworkService.data.tenant.userCanChangeEmail,
                userCanChangeName: frameworkService.data.tenant.userCanChangeName,
                userCanChangePassword: frameworkService.data.tenant.userCanChangePassword,
                userCanChangeUsername: frameworkService.data.tenant.userCanChangeUsername
            };
            vm.save = function () {
                vm.saving = true;
                tenantResource.saveUserOptions(vm.model, function () {
                    messageService.success("common.changesSaved");
                    frameworkService.data.tenant.userCanChangeEmail = vm.model.userCanChangeEmail;
                    frameworkService.data.tenant.userCanChangeName = vm.model.userCanChangeName;
                    frameworkService.data.tenant.userCanChangePassword = vm.model.userCanChangePassword;
                    frameworkService.data.tenant.userCanChangeUsername = vm.model.userCanChangeUsername;
                    vm.saving = false;
                }, function (error) {
                    messageService.error(error);
                    vm.saving = false;
                });
            };
        }
    });
}());
